<mat-toolbar color="primary">
  <ng-container *ngIf="navLeftTemplate">
    <ng-container *ngTemplateOutlet="navLeftTemplate"></ng-container>
  </ng-container>

  <span class="spacer"></span>

  <ng-container *ngIf="navRightTemplate">
    <ng-container *ngTemplateOutlet="navRightTemplate"></ng-container>
  </ng-container>
</mat-toolbar>

